
import { item, iterateIndexed, concat, tryPick } from "../../fable_modules/fable-library-js.5.13.0/Array.js";
import { memoryProblem } from "../../Common/MemoryData.js";
import { SimulationError, SimulationErrorType } from "../SimGraphTypes.js";
import { FData, FData__get_Width, FastSimulation__getSheetNameOfInstance_1A26531 } from "../SimTypes.js";
import { ofArray, map, empty, singleton } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { instrumentTime, getTimeMs } from "../../Common/TimeHelpers.js";
import { isHybridComponent } from "../SynchronousUtils.js";
import { dbg, warn } from "../../Shared/Log.js";
import { enabled } from "../../Shared/Log.js";
import { printf, toFail, concat as concat_1 } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { printComp } from "./FastOrder.js";
import { ofSeq, FSharpSet_op_Subtraction, toList } from "../../fable_modules/fable-library-js.5.13.0/Set.js";
import { compare } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.5.13.0/Result.js";
import { convertIntToFastData } from "../NumberHelpers.js";

function memoryContentsError(fs, activeComps) {
    return tryPick((fc) => {
        const matchValue = fc.FType;
        let matchResult, mem;
        switch (matchValue.tag) {
            case 40: {
                matchResult = 0;
                mem = matchValue.fields[0];
                break;
            }
            case 41: {
                matchResult = 0;
                mem = matchValue.fields[0];
                break;
            }
            case 39: {
                matchResult = 0;
                mem = matchValue.fields[0];
                break;
            }
            case 42: {
                matchResult = 0;
                mem = matchValue.fields[0];
                break;
            }
            default:
                matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const option_1 = memoryProblem(mem);
                if (option_1 != null) {
                    return new SimulationError(new SimulationErrorType(/* GenericSimError */ 20, [`The initial contents of memory ${fc.FLabel} do not fit it: ${option_1}. Change the memory's address and data widths in its Properties, or edit its contents to fit the widths it has.`]), FastSimulation__getSheetNameOfInstance_1A26531(fs, fc.AccessPath), singleton(fc.cId), empty());
                }
                else {
                    return undefined;
                }
            }
            default:
                return undefined;
        }
    }, activeComps);
}

/**
 * Check all the active FastComponents to ensure everything is valid
 * Use data from initialisation to write any not-yet-written component output widths
 */
export function checkAndValidate(fs) {
    const start = getTimeMs();
    const activeComps = fs.FCompsByIndex.filter((fc) => {
        if (fc.Active) {
            if (fc.FType.tag === 26) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    });
    const inSimulationComps = concat([fs.FClockedComps.filter((fc_1) => !isHybridComponent(fc_1.FType)), fs.FGlobalInputComps, fs.FOrderedComps]);
    if (activeComps.length !== inSimulationComps.length) {
        warn(`${activeComps.length} active components but ${inSimulationComps.length} in the simulation`);
        if ((enabled() & 32) !== 0) {
            inSimulationComps.forEach((fc_2) => {
                dbg(32, concat_1("simulation: ", printComp(fs, 0, fc_2)));
            });
            fs.FCompsByIndex.forEach((fc_3) => {
                dbg(32, concat_1("FComps: ", printComp(fs, 0, fc_3)));
            });
        }
        return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* CycleDetected */ 14, ["Issie has discovered an asynchronous cyclic path in your circuit - probably through asynchronous RAM address and dout ports. This is not allowed.This cycle detection is not precise, the components in red comprise this cycle and all components driven only from it"]), undefined, toList(FSharpSet_op_Subtraction(ofSeq(map((fc_4) => fc_4.SimComponent.Id, ofArray(activeComps)), {
            Compare: (x, y) => (compare(x, y) | 0),
        }), ofSeq(map((fc_5) => fc_5.SimComponent.Id, ofArray(inSimulationComps)), {
            Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
        }))), empty())]);
    }
    else {
        activeComps.forEach((fc_6) => {
            iterateIndexed((i, output) => {
                const matchValue_1 = output.Width | 0;
                const matchValue_2 = item(i, fc_6.Outputs).Width | 0;
                if (matchValue_1 === 0) {
                    toFail(printf("Unexpected output data width 0 found on initialised component %A %s:%d"))(fc_6.FType)(fc_6.FullName)(i);
                }
                else if (matchValue_1 !== matchValue_2) {
                    toFail(printf("Inconsistent simulation data width found on signal output: array width %d but declared width %d from %A %s:%d"))(matchValue_1)(matchValue_2)(fc_6.FType)(fc_6.FullName)(i);
                }
            }, fc_6.Outputs);
        });
        instrumentTime("checkAndValidate", start);
        const matchValue_4 = memoryContentsError(fs, activeComps);
        if (matchValue_4 == null) {
            return new FSharpResult$2(/* Ok */ 0, [fs]);
        }
        else {
            return new FSharpResult$2(/* Error */ 1, [matchValue_4]);
        }
    }
}

export function checkAndValidateFData(fs) {
    const start = getTimeMs();
    const activeComps = fs.FCompsByIndex.filter((fc) => {
        if (fc.Active) {
            if (fc.FType.tag === 26) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    });
    const inSimulationComps = concat([fs.FClockedComps.filter((fc_1) => !isHybridComponent(fc_1.FType)), fs.FGlobalInputComps, fs.FOrderedComps]);
    if (activeComps.length !== inSimulationComps.length) {
        warn(`${activeComps.length} active components but ${inSimulationComps.length} in the simulation`);
        if ((enabled() & 32) !== 0) {
            inSimulationComps.forEach((fc_2) => {
                dbg(32, concat_1("simulation: ", printComp(fs, 0, fc_2)));
            });
            fs.FCompsByIndex.forEach((fc_3) => {
                dbg(32, concat_1("FComps: ", printComp(fs, 0, fc_3)));
            });
        }
        return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* CycleDetected */ 14, ["Issie has discovered an asynchronous cyclic path in your circuit - probably through asynchronous RAM address and dout ports. This is not allowed.This cycle detection is not precise, the components in red comprise this cycle and all components driven only from it"]), undefined, toList(FSharpSet_op_Subtraction(ofSeq(map((fc_4) => fc_4.SimComponent.Id, ofArray(activeComps)), {
            Compare: (x, y) => (compare(x, y) | 0),
        }), ofSeq(map((fc_5) => fc_5.SimComponent.Id, ofArray(inSimulationComps)), {
            Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
        }))), empty())]);
    }
    else {
        activeComps.forEach((fc_6) => {
            iterateIndexed((i, output) => {
                const data = item(0, item(i, fc_6.Outputs).FDataStep);
                const expectedWidth = item(i, fc_6.Outputs).Width | 0;
                const matchValue_1 = FData__get_Width(data) | 0;
                if (expectedWidth === 0) {
                    toFail(printf("Unexpected output width 0 declared by component %A %s:%d"))(fc_6.FType)(fc_6.FullName)(i);
                }
                else if (matchValue_1 !== expectedWidth) {
                    output.FDataStep[0] = (new FData(/* Data */ 0, [convertIntToFastData(expectedWidth, 0)]));
                }
            }, fc_6.Outputs);
        });
        instrumentTime("checkAndValidate", start);
        const matchValue_3 = memoryContentsError(fs, activeComps);
        if (matchValue_3 == null) {
            return new FSharpResult$2(/* Ok */ 0, [fs]);
        }
        else {
            return new FSharpResult$2(/* Error */ 1, [matchValue_3]);
        }
    }
}

